export default __webpack_public_path__ + "media/images/news-02-370x270-e4d4b2545d787fbcc3dc34621d1e8124.jpg";